import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  CircularProgress,
  Typography,
} from "@mui/material";
import { useState } from "react";

interface Props {
  open: boolean;
  ingredient: any;
  onClose: () => void;
  onSubmit: (quantity: string) => Promise<void>;
}

const UpdateIngredientDialog = ({
  open,
  ingredient,
  onClose,
  onSubmit,
}: Props) => {

  const [quantity, setQuantity] = useState<string>(
  ingredient?.quantity?.toString() ?? ""
);

  const [loading, setLoading] = useState(false);

  const handleSave = async () => {
    setLoading(true);
    await onSubmit(quantity);
    setLoading(false);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Update Ingredient</DialogTitle>

      <DialogContent>
        <Typography fontSize={14} mb={2}>
          {ingredient?.name} ({ingredient?.unitOfMeasurement})
        </Typography>

        <TextField
        fullWidth
        label="Quantity"
        type="number"
        value={quantity}
        onChange={(e) => setQuantity(e.target.value)}
        />

      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>

        <Button
          variant="contained"
          onClick={handleSave}
          disabled={loading}
        >
          {loading ? <CircularProgress size={20} /> : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateIngredientDialog;
